export default function SkeletonCard() {
  return (
    <div className="album-card">
      <div className="skeleton skeleton-img" />
      <div className="skeleton skeleton-title" />
      <div className="skeleton skeleton-subtitle" />
    </div>
  );
}